import { IAnalyticsConfig } from '../../../core/formBuilder/formularElement';

export enum ACTION_ENUM {
  next = 'next',
  previous = 'previous',
  custom = 'custom',
  submit = 'submit',
  static = 'static',
}

export enum VARIANT_ENUM {
  outlined = 'outlined',
  contained = 'contained',
}

export interface NavigationButtonProps {
  label: string;
  variant: VARIANT_ENUM;
  action: ACTION_ENUM;
  location?: string;
  saveAndRetrieveConsent: boolean | string;
  useSARAction: boolean;
}

export interface NavigationButtonsProps {
  paddingTop?: number;
  paddingBottom?: number;
}

export interface LegacyNavigationButtonsProps extends NavigationButtonsProps {
  navigationButtons: NavigationButtonProps[];
}

export interface SingleNavigationButtonProps
  extends NavigationButtonsProps,
    NavigationButtonProps {
  horizontalAlignment?: 'left' | 'center' | 'right';
  backgroundColor?: string;
  hoverBackgroundColor?: string;
  textColor?: string;
  hoverTextColor?: string;
  analyticsConfig?: IAnalyticsConfig[];
}
